import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sexField", "form"]
  static values = {
    partnerUrl: String,
    clubUrl: String,
    redirectOnChange: { type: Boolean, default: true }
  }

  connect() {
    this._updateMode()
  }

  switchMode(event) {
    const selected = this.element.querySelector('input[name="search_mode"]:checked')
    if (!selected) return

    const mode = selected.value

    // Update visibility of sex field
    this._updateMode()

    // Only redirect if redirectOnChange is enabled (e.g., on search results pages)
    if (!this.redirectOnChangeValue) {
      // Just update form action URL without redirecting
      if (this.hasFormTarget) {
        this.formTarget.action = mode === "club" ? this.clubUrlValue : this.partnerUrlValue
      }
      return
    }

    if (mode === "club") {
      // Redirect immediately to clubs search, carrying over shared filters
      const url = new URL(this.clubUrlValue, window.location.origin)
      this._carryOverFilters(url)
      window.location.href = url.toString()
    } else {
      // Redirect immediately to partner search, carrying over shared filters
      const url = new URL(this.partnerUrlValue, window.location.origin)
      this._carryOverFilters(url)
      window.location.href = url.toString()
    }
  }

  _updateMode() {
    const selected = this.element.querySelector('input[name="search_mode"]:checked')
    if (!selected) return

    const mode = selected.value

    if (mode === "club") {
      this.sexFieldTarget.style.maxHeight = "0"
      this.sexFieldTarget.style.opacity = "0"
      this.sexFieldTarget.style.overflow = "hidden"
    } else {
      this.sexFieldTarget.style.maxHeight = "200px"
      this.sexFieldTarget.style.opacity = "1"
      this.sexFieldTarget.style.overflow = "visible"
    }

    // Dispatch event for city autocomplete to update source
    this.dispatch("modeChanged", { detail: { mode } })
  }

  _carryOverFilters(url) {
    // Carry over sex selection
    const sexInput = this.element.querySelector('input[name="sex"]:checked')
    if (sexInput && sexInput.value) {
      url.searchParams.set("sex", sexInput.value)
    }

    // Carry over city
    const cityInput = this.element.querySelector('input[name="city"]')
    if (cityInput && cityInput.value) {
      url.searchParams.set("city", cityInput.value)
    }

    // Carry over dance style IDs
    const styleCheckboxes = this.element.querySelectorAll('input[name="dance_style_ids[]"]:checked')
    styleCheckboxes.forEach(cb => {
      url.searchParams.append("dance_style_ids[]", cb.value)
    })

    // Carry over has_style_filter if any style tree is visible
    const hasStyleFilter = this.element.querySelector('input[name="has_style_filter"]')
    if (hasStyleFilter) {
      url.searchParams.set("has_style_filter", hasStyleFilter.value)
    }
  }
}
